import React from 'react';
import { Control, Controller, FieldErrors } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { ExtraCostItem } from '../../store/apiSlices/extracosts/extraCostsApiParser';
import Box from '@mui/material/Box';
import ModalFooter from '../common/ModalFooter';
import Dropdown from '../common/Dropdown';
import FormField from '../common/FormField';
import InputField from '../common/InputField';
import Modal from '../common/Modal';

type ExtraCostFormValues = {
  id: number;
  extraCostName: string;
  allocationType: string;
};

interface EditExtraCostModalProps {
  onClose: () => void;
  onSubmit: () => void;
  control: Control<ExtraCostFormValues>;
  errors?: FieldErrors<ExtraCostFormValues>;
  editingExtraCost?: ExtraCostItem | null;
  isEditMode?: boolean;
}

const EditExtraCostModal: React.FC<EditExtraCostModalProps> = ({
  onClose,
  onSubmit,
  control,
  isEditMode = false,
  errors: _errors,
  editingExtraCost: _editingExtraCost,
}) => {
  const { t } = useTranslation();
  // Allocation type options
  const allocationTypeOptions = [
    { value: 'V', label: t('extraCosts.byPrice') },
    { value: 'Q', label: t('extraCosts.byQuantity') },
    { value: 'N', label: t('extraCosts.nonFifo') },
  ];

  return (
    <Modal
      open={true}
      onClose={onClose}
      title={isEditMode ? t('extraCosts.editExtraCost') : t('extraCosts.addExtraCost')}
      size="sm"
      footer={
        <ModalFooter
          onCancel={onClose}
          onSubmit={onSubmit}
          submitText={isEditMode ? t('buttons.update') : t('buttons.add')}
        />
      }
    >
      <Box mt={3}>
        <FormField label={t('form.extraCostName')} required>
          <Controller
            name="extraCostName"
            control={control}
            rules={{ required: t('form.enterExtraCostName') }}
            render={({ field }) => (
              <InputField
                {...field}
                value={field.value || ''}
                placeholder={t('form.enterExtraCostName')}
              />
            )}
          />
        </FormField>
      </Box>

      <Box mt={3}>
        <FormField label={t('table.columns.type')} required>
          <Controller
            name="allocationType"
            control={control}
            rules={{ required: t('form.selectType') }}
            render={({ field }) => (
              <Dropdown
                value={field.value ?? ''}
                onChange={(e: any) => field.onChange(e.target.value)}
                options={allocationTypeOptions}
                placeholder={t('form.selectType')}
              />
            )}
          />
        </FormField>
      </Box>
    </Modal>
  );
};

export default EditExtraCostModal;
